module.exports = __webpack_public_path__ + "img/Veliu-Namai-no-logo.20c29a3e.jpg";